import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const ClapsAndCommentsBox = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
`;

export const Box = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  cursor: pointer;
`;

export const ClapsButton = styled(Box)`
  position: relative;

  &.activeClapImage {
    animation: scale 300ms ease-out;

    @keyframes scale {
      0% {
        transform: scale(1);
      }
      100% {
        transform: scale(1.1);
      }
    }
  }
`;

export const UserClaps = styled.p<{ concentrationClaps: number }>`
  display: none;
  position: absolute;
  width: 100%;
  left: 50%;
  transform: translate(-50%, -140%);
  color: ${({ theme }) => theme.colors.white};
  background: ${({ theme }) => theme.colors.blue};
  border-radius: 100%;
  font-size: 1.2rem;
  width: ${({ concentrationClaps }) =>
    `calc(3rem + 0.1*${concentrationClaps}rem)`};
  height: ${({ concentrationClaps }) =>
    `calc(3rem + 0.1*${concentrationClaps}rem)`};
  max-width: 4rem;
  max-height: 4rem;

  &.active {
    display: grid;
    place-items: center;

    animation: bump 630ms ease-out;
    animation: goUp 630ms ease-out;
  }

  &.activeConcentration {
    display: grid;
    place-items: center;

    animation: bump 630ms ease-out;
    animation: goUpWithoutFadeOut 630ms ease-out;
  }

  @keyframes goUp {
    0% {
      transform: translate(-50%, -80%);
      opacity: 1;
    }

    70% {
      opacity: 1;
    }

    100% {
      transform: translate(-50%, -140%);
      opacity: 0;
    }
  }

  @keyframes goUpWithoutFadeOut {
    0% {
      transform: translate(-50%, -80%);
    }

    100% {
      transform: translate(-50%, -140%);
    }
  }

  @keyframes bump {
    0% {
      transform: scale(1);
    }

    10% {
      transform: scale(0.9);
    }

    30% {
      transform: scale(1.1);
    }

    50% {
      transform: scale(1.15);
    }

    100% {
      transform: scale(1);
    }
  }
`;

export const ClapsCount = styled.p<{ claps: number }>`
  color: ${({ theme, claps }) =>
    claps ? theme.colors.blue : theme.colors.gray2};
`;
